<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">New Inbox</v-card-title>

    <v-card-text>

        <v-text-field
            label="Internal Label"
            hint="Internal only; not visible on your website"
            v-model="internal_label"
            autofocus
            autocomplete="off"
        />

        <v-text-field
            label="Help With"
            hint="Visible on your website"
            v-model="help_with"
            @keydown.enter="$event.preventDefault(); onOk();"
            autocomplete="off"
        />

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!isValid()"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');
const { v4: uuidv4 } = require('uuid');

export default {
    data() {
        return {
            dialog: false,
            
            internal_label: '',
            help_with: '',
        }
    },

    methods: {
        showDialog() 
        {
            this.internal_label = '';
            this.help_with = '';
            
            this.dialog = true;
        },

        isValid()
        {   
            if ( this.internal_label.trim().length == 0 ) return false;
            if ( this.help_with.trim().length == 0 ) return false;

            return true;
        },
        
        onOk()
        {
           this.dialog = false;

           this.$emit('ok', {
               'internal_label' : this.internal_label,
               'help_with' : this.help_with,
           });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>